import { apiSlice } from '../../api';
import type {
  GetTemplateDTO,
  GetTemplateResult,
  GetTemplatesDTO,
  GetTemplatesResult,
  UpdateTemplateResult,
  UpdateTemplateDTO,
  TestNotificationResult,
  TestNotificationDTO,
  CreateChannelResult,
  CreateChannelDTO,
  DeleteChannelDTO,
  DeleteChannelResult,
} from './types';

const adminNotificationsEndpoints = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getTemplates: build.query<GetTemplatesResult, GetTemplatesDTO>({
      query: () => ({
        url: '/admin/v1/notifications/templates',
        method: 'GET',
      }),
      providesTags: ['NotificationTemplates'],
    }),

    getTemplate: build.query<GetTemplateResult, GetTemplateDTO>({
      query: ({ eventName }) => ({
        url: `/admin/v1/notifications/templates/${eventName}`,
        method: 'GET',
      }),
      providesTags: ['NotificationTemplate'],
    }),

    updateTemplate: build.mutation<UpdateTemplateResult, UpdateTemplateDTO>({
      query: ({ eventName, body }) => ({
        url: `/admin/v1/notifications/templates/${eventName}`,
        method: 'PUT',
        body,
      }),
      invalidatesTags: ['NotificationTemplate', 'NotificationTemplates'],
    }),

    testNotification: build.mutation<TestNotificationResult, TestNotificationDTO>({
      query: ({ body }) => ({
        url: '/admin/v1/notifications/test',
        method: 'POST',
        body,
      }),
    }),

    createChannel: build.mutation<CreateChannelResult, CreateChannelDTO>({
      query: ({ event, body }) => ({
        url: `/admin/v1/notificatios/templates/${event}/channels`,
        method: 'POST',
        body,
      }),
    }),

    deleteChannel: build.mutation<DeleteChannelResult, DeleteChannelDTO>({
      query: ({ event, channel_id }) => ({
        url: `/admin/v1/notificatios/templates/${event}/channels/${channel_id}`,
        method: 'delete',
      }),
    }),
  }),
});

export const { useGetTemplatesQuery } = adminNotificationsEndpoints;
export const { useGetTemplateQuery } = adminNotificationsEndpoints;
export const { useUpdateTemplateMutation } = adminNotificationsEndpoints;
export const { useTestNotificationMutation } = adminNotificationsEndpoints;
export const { useCreateChannelMutation } = adminNotificationsEndpoints;
export const { useDeleteChannelMutation } = adminNotificationsEndpoints;

export type AdminNotificationsController = typeof adminNotificationsEndpoints;
